/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

export type GetWebparseMetadataRequest = { url: string };

export const GetWebparseMetadataRequest$zodSchema: z.ZodType<
  GetWebparseMetadataRequest
> = z.object({
  url: z.string().describe("需要提取元数据的网页URL"),
});

export type GetWebparseMetadataInternalServerErrorDetails = {};

export const GetWebparseMetadataInternalServerErrorDetails$zodSchema: z.ZodType<
  GetWebparseMetadataInternalServerErrorDetails
> = z.object({});

/**
 * 服务器内部错误
 */
export type GetWebparseMetadataInternalServerErrorResponseBody = {
  code?: string | undefined;
  details?: GetWebparseMetadataInternalServerErrorDetails | undefined;
  message?: string | undefined;
};

export const GetWebparseMetadataInternalServerErrorResponseBody$zodSchema:
  z.ZodType<GetWebparseMetadataInternalServerErrorResponseBody> = z.object({
    code: z.string().optional(),
    details: z.lazy(() =>
      GetWebparseMetadataInternalServerErrorDetails$zodSchema
    ).optional(),
    message: z.string().optional(),
  }).describe("服务器内部错误");

export type GetWebparseMetadataBadRequestDetails = {};

export const GetWebparseMetadataBadRequestDetails$zodSchema: z.ZodType<
  GetWebparseMetadataBadRequestDetails
> = z.object({});

/**
 * URL参数缺失或无效
 */
export type GetWebparseMetadataBadRequestResponseBody = {
  code?: string | undefined;
  details?: GetWebparseMetadataBadRequestDetails | undefined;
  message?: string | undefined;
};

export const GetWebparseMetadataBadRequestResponseBody$zodSchema: z.ZodType<
  GetWebparseMetadataBadRequestResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => GetWebparseMetadataBadRequestDetails$zodSchema)
    .optional(),
  message: z.string().optional(),
}).describe("URL参数缺失或无效");

export type OpenGraph = {};

export const OpenGraph$zodSchema: z.ZodType<OpenGraph> = z.object({});

/**
 * 成功响应
 */
export type GetWebparseMetadataResponseBody = {
  page_url?: string | undefined;
  title?: string | undefined;
  description?: string | undefined;
  keywords?: Array<string> | undefined;
  favicon_url?: string | undefined;
  language?: string | undefined;
  author?: string | undefined;
  published_time?: string | undefined;
  canonical_url?: string | undefined;
  generator?: string | undefined;
  open_graph?: OpenGraph | undefined;
};

export const GetWebparseMetadataResponseBody$zodSchema: z.ZodType<
  GetWebparseMetadataResponseBody
> = z.object({
  author: z.string().optional(),
  canonical_url: z.string().optional(),
  description: z.string().optional(),
  favicon_url: z.string().optional(),
  generator: z.string().optional(),
  keywords: z.array(z.string()).optional(),
  language: z.string().optional(),
  open_graph: z.lazy(() => OpenGraph$zodSchema).optional(),
  page_url: z.string().optional(),
  published_time: z.string().optional(),
  title: z.string().optional(),
}).describe("成功响应");

export type GetWebparseMetadataResponse =
  | GetWebparseMetadataResponseBody
  | GetWebparseMetadataBadRequestResponseBody
  | GetWebparseMetadataInternalServerErrorResponseBody;

export const GetWebparseMetadataResponse$zodSchema: z.ZodType<
  GetWebparseMetadataResponse
> = z.union([
  z.lazy(() => GetWebparseMetadataResponseBody$zodSchema),
  z.lazy(() => GetWebparseMetadataBadRequestResponseBody$zodSchema),
  z.lazy(() => GetWebparseMetadataInternalServerErrorResponseBody$zodSchema),
]);
